/**
 * Date input accepted by CV edit forms (month is never blocking):
 * - '' (empty, dates are optional)
 * - 'CURRENT' (marker for "still in progress")
 * - 'YYYY' (year alone — the candidate only knows the year)
 * - 'MM/YYYY' (typed by the user, matches the form placeholders)
 * - 'YYYY-MM' / 'YYYY-MM-DD' (internal storage formats)
 */
export const isValidDateInput = (value: string): boolean =>
  value === '' ||
  value === 'CURRENT' ||
  /^\d{4}$/.test(value) ||
  /^(0[1-9]|1[0-2])\/\d{4}$/.test(value) ||
  /^\d{4}-(0[1-9]|1[0-2])(-\d{2})?$/.test(value);
